module.exports = __webpack_public_path__ + "img/Frame 1095one5.bbded7a3.png";